import { useEffect, useState } from 'react';

export default function useDebouncedValue<T = any>(value: T, delay = 500) {
  const [_value, _setValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => {
      _setValue(value);
    }, delay);
    return () => clearTimeout(timeout);
  }, [value, delay]);

  return _value;
}
